import { Link } from 'react-router-dom';
import { BRAND_LOGO_URL } from './constants';

export const LandingFooter = () => (
  <footer className="border-t border-border bg-secondary/20 py-8">
    <div className="max-w-6xl mx-auto px-6">
      <div className="flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <img src={BRAND_LOGO_URL} alt="Icarus D&D" className="h-6 w-auto max-w-[120px] object-contain" style={{ mixBlendMode: 'multiply' }} />
          <a
            href="https://www.icarus-nutrition.de"
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs text-muted-foreground hover:text-primary transition-colors"
          >
            icarus-nutrition.de
          </a>
        </div>
        <div className="flex items-center gap-6 text-xs text-muted-foreground">
          <Link to="/pricing" className="hover:text-foreground transition-colors">Preise</Link>
          <a href="mailto:info@icarus-health.de" className="hover:text-foreground transition-colors">
            Kontakt
          </a>
          <Link to="/impressum" className="hover:text-foreground transition-colors">Impressum</Link>
          <Link to="/datenschutz" className="hover:text-foreground transition-colors">Datenschutz</Link>
          <Link to="/agb" className="hover:text-foreground transition-colors">AGB</Link>
        </div>
      </div>
      <div className="text-center mt-4 text-xs text-muted-foreground/80">
        Icarus Health UG (haftungsbeschränkt) &middot; Alle Rechte vorbehalten
      </div>
    </div>
  </footer>
);
